<template>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0 file-datatable">
        <h5 class="mb-2">{{ $t('attachment') }}</h5>


        <app-table :id="tableId" id="file-table" :filtered-data="filteredData" :options="options"/>
    </div>
</template>

<script>
    import * as actions from "../../../../../Config/ApiUrl";


    export default {
        name: "fileDatatable",
        props: {
           courseId: String
        },
        data() {
            return {
                preloader: false,
                tableId: 'file-table',
                filteredData: {
                    status: '',
                },
                options: {
                    url: actions.FILES_ATTACHMENT_DATA,
                    name: this.$t('basic_list_view_table'),
                    showHeader: false,
                    columns: [
                        {
                            title: this.$t('attachment'),
                            type: 'custom-html',
                            key: 'dropzone_file',
                            modifier: (value) => {
                                if (value) {
                                    let filename_formatted = value.split("/").pop().replace(/\-\d.*/,'');
                                    let filetype = '.'+value.split(".").pop();
                                    let target = '_self';

                                    if(filetype == '.jpg' || filetype == '.jpeg' || filetype == '.png' || filetype == '.gif' || filetype == '.webp' || filetype == '.pdf'){
                                        target = '_blank';
                                    }

                                    return `<a href="${value}" target="${target}" title="${filename_formatted}${filetype}"><i class="custom-icon custom-icon-documents custom-icon-light float-left"></i> ${filename_formatted}${filetype}</a>`;


                                }
                            }

                        },
                    ],
                    filters: [
                        {
                            "title": this.$t('course_id'),
                            "type": "hidden",
                            "key": "filter-with-course",
                            "initValue": this.courseId,
                            "option": [],
                        },
                    ],
                    showFilter: false,
                    showSearch: false,
                    datatableWrapper: true,
                    actions:[],
                    responsive: false,
                    rowLimit: 10,
                    emptyText: "", // Text if zero results
                    showAction: false,
                    showCount: false,
                    showClearFilter: false,
                    paginationType: "pagination",
                    managePagination: false,
                    tableShadow: false,
                    tablePaddingClass: '',
                    orderBy: 'desc',
                },

                methods: {
                    /**
                    * get Status Filter
                    */
                    getSearchValue(value) {
                        let instance = this;
                        this.search = value;
                        setTimeout(function () {
                            instance.$hub.$emit('reload-' + instance.tableId);
                        });
                    },
                    getFilterValue(item) {
                        this.filteredData.status = item;
                        console.log('test '+item);
                        this.$hub.$emit('reload-'+this.tableId);
                    }

                }
            }
        }
    }
</script>
